import {Component, OnDestroy, OnInit} from '@angular/core';
import {CartService} from '../../shopping-cart/cart.service';
import {Subscription} from 'rxjs';
import {Cart} from '../../shopping-cart/Cart';

@Component({
  selector: 'app-cart-badge',
  templateUrl: './cart-badge.component.html',
  styleUrls: ['./cart-badge.component.scss'],
  standalone: true,
})
export class CartBadgeComponent implements OnInit, OnDestroy {

  itemCount = 0;
  subscription: Subscription;

  constructor(private readonly cartService: CartService) {
  }

  ngOnInit(): void {
    const observer = {
      next: (cart) => {
        this.itemCount = this.countCartItems(cart);
      },
      error: () => {
        this.itemCount = 0;
      },
    };
    this.subscription = this.cartService.observable.subscribe(observer);
  }

  ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public countCartItems(cart: Cart): number {
    if (!cart || !cart.items) {
      return 0;
    }
    return cart.items.map(item => item.quantity)
      .reduce((previous, current) => current + previous, 0);
  }

}
